import * as _ from 'lodash';
import toastr from 'toastr';
import ApiService from '../../../service/apiService';
import logUtils from '../../../HelperMethods/LogUtils';
import * as Utility from '../../../HelperMethods/UtilityFunctions';
import { mergeAssetWithAreas, userListtoUserPicklist } from '../helper';
import { getUsersApi } from '../../../HelperMethods/apiHelper';
import { getAllItems, getPickListOptions, elasticSearchUtil } from '../../../HelperMethods/UtilityFunctions';
// eslint-disable-next-line import/no-cycle
import { deleteAssetMapper, attachmentMerge } from '../AssetManagementForm/lib/Mapper';
import { PREFERRED_LOCATION_TYPE } from '../../../HelperMethods/constants';

// eslint-disable-next-line import/no-cycle
import {
  loadRequiredAssets,
  setLoader,
  setGridParam as setGridParamInReducer,
  setPreferredLocationTypePicklist,
  setIsExporting,
} from './reducer';

export const types = {
  ASSET_LOADED_SUCCESS: 'ASSET_LOADED_SUCCESS',
  ASSET_LOADING: 'ASSET_LOADING',
  SET_STOP_ID: 'SET_STOP_ID',
  ASSET_LOAD_FAILED: 'ASSET_LOAD_FAILED',
  UPDATE_ASSETS_UPLOAD_IN_PROGRESS: 'UPDATE_ASSETS_UPLOAD_IN_PROGRESS',
  UPDATE_ASSETS_UPLOAD_SUCCESSFULL: 'UPDATE_ASSETS_UPLOAD_SUCCESSFULL',
  UPDATE_ASSETS_UPLOAD_FAILED: 'UPDATE_ASSETS_UPLOAD_FAILED',
  UPDATE_ASSETS_UPLOAD_RESET: 'UPDATE_ASSETS_UPLOAD_RESET',
  LOAD_USERS_FROM_FIELD: 'LOAD_USERS_FROM_FIELD',
  LOADING_USERS_FROM_FIELD_SUCCESSFULL: 'LOADING_USERS_FROM_FIELD_SUCCESSFULL',
  LOAD_STOPS_FROM_FIELD: 'LOAD_STOPS_FROM_FIELD',
  LOADING_STOPS_FROM_FIELD_UNSUCCESSFULL: 'LOADING_STOPS_FROM_FIELD_UNSUCCESSFULL',
  LOADING_STOPS_FROM_FIELD_SUCCESSFULL: 'LOADING_STOPS_FROM_FIELD_SUCCESSFULL',
  LOADING_USERS_FROM_FIELD_UNSUCCESSFULL: 'LOADING_USERS_FROM_FIELD_UNSUCCESSFULL',
  LOAD_FIELD_PICKLIST: 'LOAD_FIELD_PICKLIST',
  LOAD_FIELD_PICKLIST_FAIL: 'LOAD_FIELD_PICKLIST_FAIL',
  RELOAD_ASSET_DETAILS: 'RELOAD_ASSET_DETAILS',
  STORING_ASSET_IN_LOCAL: 'STORING_ASSET_IN_LOCAL',
  REMOVING_ASSET_IN_LOCAL: 'REMOVING_ASSET_IN_LOCAL',
  BULK_ASSET_LOAD: 'BULK_ASSET_LOAD',
  STOP_LIST: 'STOP_LIST',
  BULK_ASSET_LOAD_SUCCESFULL: 'BULK_ASSET_LOAD_SUCCESFULL',
  BULK_ASSET_LOAD_UNSUCCESFULL: 'BULK_ASSET_LOAD_UNSUCCESFULL',
  ASSET_GEOFENCE_TO_REDUX: 'ASSET_GEOFENCE_TO_REDUX',
  ASSET_GEOFENCE_UPDATE: 'ASSET_GEOFENCE_UPDATE',
  REMOVE_GEOFENCE_FROM_LOCAL: 'REMOVE_GEOFENCE_FROM_LOCAL',
  DYNAMO_RESPONSE: 'DYNAMO_RESPONSE',
  REMOVE_DYNAMO_RESPONSE: 'REMOVE_DYNAMO_RESPONSE',
};

export function setGridParam(param) {
  return async (dispatch) => {
    dispatch(setGridParamInReducer(param));
  };
}

export function uploadAssetsToUpdate(dataToUpdate, key) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_ASSETS_UPLOAD_IN_PROGRESS });
    try {
      const output = await ApiService.uploadAssetsToUpdate(dataToUpdate, key);
      const assetsUpdated = Utility.inflateResponse(output);
      dispatch({ type: types.UPDATE_ASSETS_UPLOAD_SUCCESSFULL, updatedAssetsAfterUpload: assetsUpdated });
    } catch (e) {
      logUtils.logError(e, 'Asset Info upload Failed');
      dispatch({ type: types.UPDATE_ASSETS_UPLOAD_FAILED });
    }
  };
}

export function loadFileds(fieldDict) {
  return async (dispatch) => {
    try {
      const fieldDictionary = _.keyBy(fieldDict, 'id');
      const returnObj = [];
      if (Object.keys(fieldDictionary).length > 0) {
        // eslint-disable-next-line guard-for-in
        Object.keys(fieldDictionary).forEach((fieldId, index) => {
          returnObj.push({ key: index, value: fieldId, text: _.get(fieldDictionary[fieldId], 'name') });
        });
      }

      dispatch({ type: types.LOAD_FIELD_PICKLIST, items: returnObj });
    } catch (error) {
      toastr.error('Failed to load fields');
      dispatch({ type: types.LOAD_FIELD_PICKLIST_FAIL, items: [] });
    }
  };
}
export function loadStopsForField() {
  return async (dispatch, getState) => {
    dispatch({ type: types.LOAD_STOPS_FROM_FIELD });

    try {
      const stopsList = getState().stopsReducer.stops.map(({ name, id }, index) => ({
        key: index,
        text: name,
        value: id,
      }));

      dispatch({ type: types.LOADING_STOPS_FROM_FIELD_SUCCESSFULL, stopsList });
    } catch (error) {
      dispatch({ type: types.LOADING_STOPS_FROM_FIELD_UNSUCCESSFULL, stopsList: [] });
      toastr.error('could not fetch users');
    }
  };
}

export function loadUsersFromField(fieldID) {
  return async (dispatch) => {
    dispatch({ type: types.LOAD_USERS_FROM_FIELD });
    const params = Utility.getSearchgraphQLformultiplefieldId([fieldID]);
    try {
      const responseUsers = await getAllItems(getUsersApi, 'searchUsers', params);
      const users = responseUsers.map((user) => userListtoUserPicklist(user));
      dispatch({ type: types.LOADING_USERS_FROM_FIELD_SUCCESSFULL, users });
    } catch (error) {
      dispatch({ type: types.LOADING_USERS_FROM_FIELD_UNSUCCESSFULL, users: [] });
      toastr.error('could not fetch users');
    }
  };
}
export function uploadAssetsReset() {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_ASSETS_UPLOAD_RESET });
  };
}

export function updateAssetStore(asset) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.STORING_ASSET_IN_LOCAL, asset });
    } catch (error) {
      console.debug(error);
    }
  };
}

export function removeUpdateAssetStore() {
  return async (dispatch) => {
    try {
      dispatch({ type: types.REMOVING_ASSET_IN_LOCAL });
    } catch (error) {
      console.debug(error);
    }
  };
}

function responseCleaner(response) {
  const processedItems = [];
  const unProcessedItems = [];

  const tempClean = response.flatMap((val) => val.output);
  tempClean.forEach((c) => {
    Object.keys(c).forEach((p) => {
      if (p === 'processedItems') {
        c.processedItems.forEach((r) => {
          processedItems.push(r);
        });
      }
      if (p === 'unProcessedItems') {
        c.unProcessedItems.forEach((r) => {
          unProcessedItems.push(r);
        });
      }
    });
  });
  return { processedItems, unProcessedItems };
}

async function batchWriteAsset(updatedAsset) {
  try {
    const promises = [];

    const tempChunk = _.chunk(updatedAsset, 1000);

    tempChunk.forEach((chunk) => {
      promises.push(ApiService.upsertAsset(chunk));
    });
    const response = await Promise.all(promises);

    return responseCleaner(response);
  } catch (error) {
    return undefined;
  }
}

export function bulkAdd({ correctArray, incorrectArray, assetType }) {
  return async (dispatch) => {
    try {
      dispatch(setLoader(true));
      const correctAssetArray = [];
      const incorrectAssetArray = _.clone(incorrectArray);
      const response = await batchWriteAsset(correctArray);

      if (!response) {
        throw new Error('Bulk Upload failed');
      }

      response.processedItems.forEach((processedItems) => {
        if (assetType === 'nostop') {
          correctArray.forEach((correctArrayitems) => {
            if (correctArrayitems.name === processedItems.record.name) {
              const { name } = correctArrayitems.stop;
              correctAssetArray.push({
                ...processedItems.record,
                stop: { name },
                message: processedItems.message,
              });
            }
          });
        } else correctAssetArray.push({ ...processedItems.record, message: processedItems.message });
      });
      response.unProcessedItems.forEach((unProcessedItems) => {
        const { record } = unProcessedItems;

        incorrectAssetArray.push({ ...record, message: unProcessedItems.message });
      });

      dispatch({
        type: types.BULK_ASSET_LOAD_SUCCESFULL,
        correctAsset: [...correctAssetArray],
        incorrectAsset: [...incorrectAssetArray],
        assetType,
      });

      dispatch(setLoader(false));
    } catch (error) {
      logUtils.logError(error);
      dispatch(setLoader(false));
    }
  };
}

function getFieldNamefromId(id, fieldDict) {
  const { name } = fieldDict[id];
  return name || '';
}

export function updateAsset(asset) {
  return async (dispatch, getState) => {
    try {
      dispatch(setLoader(true));
      const updatedAsset = [];
      const { reloadAssetState } = getState().assetReducer;
      const sendAsset = _.cloneDeep(asset);
      const { attachments } = getState().attachmentManagementReducer;
      sendAsset.forEach((assetObj) => {
        assetObj.attachments = attachmentMerge(assetObj, attachments);
        updatedAsset.push(assetObj);
      });
      const fieldDict = _.keyBy(getState().appReducer.fieldsForDropdown, 'id');
      const response = await ApiService.upsertAsset(updatedAsset);
      const processedItems = _.get(response, 'output.processedItems', []).map((e) => e.record);
      if (response && response.output && !_.isEmpty(response.output.unProcessedItems)) {
        const { message } = response.output.unProcessedItems[0];

        if (
          message.includes('ValidationError') &&
          _.isArray(sendAsset) &&
          sendAsset.length === 1 &&
          sendAsset[0].type !== 'stop'
        ) {
          const fieldId = response.output.unProcessedItems[0].record.field?.id || '';
          const fieldName = getFieldNamefromId(fieldId, fieldDict);
          throw new Error(`Asset already exists and Assets field ${fieldName} is not similar with other entities `);
        } else if (
          message.includes('ValidationError') &&
          _.isArray(sendAsset) &&
          sendAsset.length === 1 &&
          sendAsset[0].type === 'stop'
        ) {
          const fieldId = response.output.unProcessedItems[0].record.field?.id || '';
          const fieldName = getFieldNamefromId(fieldId, fieldDict);
          throw new Error(`Asset already exists and Assets field ${fieldName} is not similar with other entities `);
        } else throw new Error('Assets Saving failed');
      }
      if (sendAsset && _.isArray(sendAsset) && sendAsset.length === 1) {
        // eslint-disable-next-line no-unused-expressions
        response.output.processedItems[0].message.includes('Item got updated')
          ? toastr.success('Item got Updated')
          : toastr.success('Item got created');
      } else if (sendAsset && _.isArray(sendAsset) && sendAsset.length > 1) {
        let processedItemsCount = 0;
        let unproccessedItemCount = 0;
        response.output.processedItems.forEach(() => {
          processedItemsCount += 1;
        });
        response.output.unProcessedItems.forEach(() => {
          unproccessedItemCount += 1;
        });
        if (unproccessedItemCount > 0) {
          toastr.Error(`bulk Update failed for ${unproccessedItemCount} Assets`);
          dispatch(setLoader(false));

          return false;
        }
        toastr.success(`bulk Update successful for ${processedItemsCount} Assets`);
        dispatch(setLoader(false));

        return true;
      }
      dispatch({ type: types.REMOVE_GEOFENCE_FROM_LOCAL });
      dispatch({ type: types.DYNAMO_RESPONSE, dynamoResponse: processedItems });
      dispatch({ type: types.RELOAD_ASSET_DETAILS, reloadAssetState: !reloadAssetState });
      dispatch(setLoader(false));
    } catch (error) {
      logUtils.logError(error, error);
      dispatch(setLoader(false));
    }
    return null;
  };
}

export function getAssetbyIds(assetIds) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: types.ASSET_LOADING });
      const response = await ApiService.getAssetsByIds([assetIds]);

      if (!response) throw new Error('Asset fetch failed');
      const { allAreas } = getState().appReducer;
      const mergedAsset = mergeAssetWithAreas({ assets: response }, allAreas);
      if (!mergedAsset.assets[0]) throw new Error('Asset fetch failed');
      dispatch({ type: types.ASSET_LOADED_SUCCESS, asset: mergedAsset.assets[0] });
      dispatch({ type: types.ASSET_GEOFENCE_TO_REDUX, asset: mergedAsset.assets[0] });
      return mergedAsset.assets[0];
    } catch (error) {
      dispatch({ type: types.ASSET_LOAD_FAILED });

      logUtils.logError(error, 'Assets Fetching failed');
    }
    return {};
  };
}

export function assetGeofenceUpdate(geofence) {
  return async (dispatch) => {
    dispatch({ type: types.ASSET_GEOFENCE_UPDATE, geofence });
  };
}

export function stopSelectionId(stopId) {
  return async (dispatch) => {
    try {
      dispatch({ type: types.SET_STOP_ID, stopId });
    } catch (error) {
      logUtils.logError(error, 'Failed');
    }
  };
}

export function fetchAssets(data = {}, param) {
  return async (dispatch, getState) => {
    dispatch(setLoader(true));
    let output = [];
    try {
      const { fieldId, selectedStopId } = data;
      const apiParam = { fieldId, size: 50 };
      const { assets = [] } = getState().assetReducer.assetlist;
      const { selectedAreas, areasForDropdown, allAreas, selectedField } = getState().appReducer;
      const { dynamoResponse } = getState().assetReducer;
      const { startRow: startRowInReducer } = getState().assetReducer.gridParam;
      const { startRow } = param;
      const showNextPage = startRow > startRowInReducer;
      if (showNextPage) {
        const reqAsset = assets[assets.length - 1];
        if (reqAsset) {
          apiParam.nextToken = [new Date(reqAsset.modifiedOn).getTime(), reqAsset.id];
        }
      }
      if (_.size(param.filterModel)) {
        apiParam.filters = _.clone(param.filterModel);
      }
      if (_.size(param.sortModel)) {
        apiParam.sort = _.clone(param.sortModel);
      }
      if (_.size(selectedAreas)) {
        apiParam.areaIds = selectedAreas.map((val) => val.id);
        apiParam.isAreasSelected = true;
      } else {
        apiParam.areaIds = areasForDropdown.map((val) => val.id);
      }
      if (selectedStopId) {
        apiParam.stopId = selectedStopId;
      }
      output = await ApiService.getAssetsByCustomFilters(apiParam);
      const assetsInReducer = JSON.parse(JSON.stringify(dynamoResponse));
      const computedAssets = elasticSearchUtil(assetsInReducer, _.get(output, 'assets', []), [selectedField.id]);
      const mergedAsset = mergeAssetWithAreas(
        {
          assets: computedAssets,
          total: _.get(output, 'total'),
        },
        allAreas
      );
      output = mergedAsset;
      dispatch(loadRequiredAssets(mergedAsset));
      dispatch(setGridParam(param));
      dispatch({ type: types.REMOVE_DYNAMO_RESPONSE });
    } catch (e) {
      logUtils.logError(e, 'Assets Fetching failed');
      dispatch(loadRequiredAssets([]));
    } finally {
      dispatch(setLoader(false));
    }
    return output;
  };
}
export function deleteAttribute(asset) {
  return async (dispatch) => {
    try {
      dispatch(setLoader(true));
      // const { selectedField } = getState().appReducer;
      // const { searchStopId, gridParam } = getState().assetReducer;

      const assettoDelete = deleteAssetMapper(asset);

      const response = await ApiService.upsertAsset([assettoDelete]);

      if (!response || (response.processedItems && response.processedItems.length === 0))
        throw new Error('Asset Delete failed');
      // dispatch(fetchAssets({ selectedField, searchStopId }, gridParam));
    } catch (error) {
      logUtils.logError(error, 'Asset Delete Failed');
      dispatch(setLoader(false));
    }
  };
}

// PREFERRED_LOCATION_TYPE

export function getPreferredLocationTypePicklist() {
  return async (dispatch) => {
    const params = {
      filter: {
        name: {
          eq: PREFERRED_LOCATION_TYPE,
        },
      },
    };
    try {
      const response = await ApiService.searchPicklist(params);
      const pickLists = _.get(response, 'data.searchPicklists.items', []) || [];
      if (!pickLists || pickLists.length === 0) {
        // eslint-disable-next-line no-throw-literal
        throw { message: `${PREFERRED_LOCATION_TYPE} list is not found` };
      }
      const options = pickLists[0].options ? JSON.parse(pickLists[0].options) : {};
      const pickListOptions = getPickListOptions(Object.values(options));
      const picklist = { ...(pickLists[0] || {}), options: pickListOptions };
      dispatch(setPreferredLocationTypePicklist(picklist));
    } catch (e) {
      const message = e instanceof Error ? `${PREFERRED_LOCATION_TYPE} List Failed` : e.message;
      logUtils.logError(e, message);
      dispatch(setPreferredLocationTypePicklist({}));
    }
  };
}

export function exportAllAssets(data = {}, columns) {
  return async (dispatch, getState) => {
    dispatch(setIsExporting(true));
    let output = '';
    try {
      const { fieldId, selectedStopId } = data;
      const apiParam = {
        fieldId,
      };
      const param = getState().assetReducer.gridParam;
      const { selectedAreas, areasForDropdown } = getState().appReducer;
      if (_.size(param?.filterModel)) {
        apiParam.filters = _.clone(param?.filterModel);
      }
      if (_.size(selectedAreas)) {
        apiParam.areaIds = selectedAreas.map((val) => val.id);
        apiParam.isAreasSelected = true;
      } else {
        apiParam.areaIds = areasForDropdown.map((val) => val.id);
      }
      if (Array.isArray(columns)) {
        apiParam.columns = columns;
      }
      if (selectedStopId) {
        apiParam.stopId = selectedStopId;
      }
      apiParam.isAllData = true;
      console.log(apiParam);
      output = await ApiService.exportAllAssets(apiParam);
    } catch (e) {
      logUtils.logError(e, 'Assets exporting failed');
    } finally {
      dispatch(setIsExporting(false));
    }
    return output;
  };
}
